import { render, staticRenderFns } from "./ResultPriceCard.vue?vue&type=template&id=6ed2ea66"
import script from "./ResultPriceCard.vue?vue&type=script&lang=js"
export * from "./ResultPriceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports